export default __webpack_public_path__ + "static/media/kargil1.13f63593.jpg";